import { graphql } from '~/gql'

export default graphql(`
  mutation authorizeSalesforceClient($code: String!, $redirectUrl: String!) {
    authorizeSalesforceClient(code: $code, redirectUrl: $redirectUrl)
  }
`)
